// state/actions/authActions.js
import { setAuth, setChecked } from "state/slices/authSlice";
import {
  AUTH_BOOTSTRAP_START,
  AUTH_BOOTSTRAP_SUCCESS,
  AUTH_BOOTSTRAP_FAILURE,
} from "state/types/actionTypes";

import apiClient from "../../api/apiClient";

// action creators (same shape as layersActions)
export const authBootstrapStart = () => ({ type: AUTH_BOOTSTRAP_START });
export const authBootstrapSuccess = (user) => ({
  type: AUTH_BOOTSTRAP_SUCCESS,
  payload: user,
});
export const authBootstrapFailure = (error) => ({
  type: AUTH_BOOTSTRAP_FAILURE,
  payload: error,
});

// thunk (cookie-based session bootstrap)
export const bootstrapAuth = () => async (dispatch) => {
  dispatch(authBootstrapStart());
  try {
    const { data: s } = await apiClient.get(
      `${process.env.REACT_APP_BASE_URL}/user/session`,
      { withCredentials: true },
    );
    if (!s.authenticated) {
      dispatch(setAuth({ isAuthenticated: false, user: null }));
      dispatch(authBootstrapSuccess(null));
      return;
    }
    const { data } = await apiClient.get(
      `${process.env.REACT_APP_BASE_URL}/user/me`,
      { withCredentials: true },
    );
    dispatch(setAuth({ isAuthenticated: true, user: data.user }));
    dispatch(authBootstrapSuccess(data.user));
  } catch (err) {
    dispatch(setAuth({ isAuthenticated: false, user: null }));
    dispatch(authBootstrapFailure(err?.message || "bootstrap failed"));
  } finally {
    dispatch(setChecked(true));
  }
};
